import React, { useState, useEffect, useRef, useCallback, } from "react";
import { keyPress } from "../../utils/keyPress";
import { FilterWrapper } from "./FilterWrapper";
import { Typeahead } from "../../Typeahead";
import { useFormContext } from "../../Form";
export var FutureAsyncFilter = function (_a) {
    var _b;
    var onChange = _a.onChange, loadOptions = _a.loadOptions, label = _a.label, formatter = _a.formatter, extraClass = _a.extraClass, _c = _a.direction, direction = _c === void 0 ? "right" : _c, name = _a.name, id = _a.id;
    var _d = useState(false), isMenuVisible = _d[0], setIsMenuVisible = _d[1];
    var values = useFormContext().values;
    var existingFormValue = (_b = values.get(name)) !== null && _b !== void 0 ? _b : null;
    var elementRef = useRef(null);
    var mouseDownHandler = useCallback(function (ev) {
        if (elementRef.current) {
            if (!elementRef.current.contains(ev.target)) {
                setIsMenuVisible(false);
            }
        }
    }, []);
    var onTypeaheadChange = useCallback(function (selected) {
        /** TODO useReducer to handle states */
        if (selected) {
            if (onChange) {
                onChange(selected);
            }
            if (isMenuVisible)
                setIsMenuVisible(false);
        }
        else {
            if (onChange) {
                onChange(selected);
            }
            if (isMenuVisible)
                setTimeout(function () {
                    setIsMenuVisible(false);
                });
        }
    }, [onChange, isMenuVisible]);
    var keyFunctions = useCallback(function (event) {
        if (event.keyCode === keyPress.ESCAPE) {
            setIsMenuVisible(false);
        }
    }, [setIsMenuVisible]);
    useEffect(function () {
        /* TODO Make into a Hook */
        if (isMenuVisible) {
            document.addEventListener("keydown", keyFunctions, false);
        }
        document.addEventListener("mousedown", mouseDownHandler);
        return function () {
            if (isMenuVisible) {
                document.removeEventListener("keydown", keyFunctions, false);
            }
            document.removeEventListener("mousedown", mouseDownHandler);
        };
    }, [keyFunctions, mouseDownHandler, isMenuVisible]);
    return (React.createElement("div", { ref: elementRef, id: id },
        React.createElement(FilterWrapper, { visible: isMenuVisible, onChange: function () { return setIsMenuVisible(!isMenuVisible); }, label: label, value: existingFormValue &&
                (formatter ? formatter(existingFormValue) : existingFormValue.name) },
            React.createElement("div", { className: "affectBar--filter-box affectBar--filter-box--".concat(direction, " ").concat(extraClass ? extraClass : "") },
                React.createElement(Typeahead, { name: name, loadOptions: loadOptions, onChange: onTypeaheadChange, label: label, formatter: formatter, autoFocus: true, uniqueId: id })))));
};
